import SectionHeading from "@/pages/home/components/SectionHeading";
import { accessMethods } from "@/mocks/doumanData";

export default function AccessSection() {
  return (
    <section id="access" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="访问入口"
          title="抖漫的四种访问途径，总有一种适合你"
          desc="不同设备、不同场景适合的进入方式并不一样。先了解各自的优缺点，再挑选最顺手的一种，能省下不少找入口的时间。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {accessMethods.map((method) => (
            <article
              key={method.title}
              className="p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start gap-4">
                <span className="shrink-0 w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${method.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading font-bold text-lg text-foreground-950">{method.title}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs font-bold">
                      {method.badge}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{method.desc}</p>
                </div>
              </div>
              <ul className="mt-5 space-y-2.5">
                {method.points.map((point) => (
                  <li key={point} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5" aria-hidden="true"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}